import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    meta: {
      title: "登录/注册",
    },
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/",
    meta: {
      title: "首页",
    },
    component: () => import("../views/home/home.vue"),
  },
  {
    path: "/resources",
    meta: {
      title: "资源页面",
    },
    component: () => import("../views/resources/resources.vue"),
  },
  {
    path: "/resources/detail/:planId",
    name: "CourseDetail",
    meta: {
      title: "课程详情",
    },
    component: () => import("../views/resources/course-detail.vue"),
  },
  {
    path: "/resources/file-list",
    name: "FileList",
    component: () => import("../views/resources/file-list.vue"),
    meta: {
      title: "File List"
    }
  },
  {
    path: "/resources/pdf-viewer",
    name: "PdfViewer",
    component: () => import("../views/resources/pdf-viewer.vue"),
    meta: {
      title: "PDF Viewer"
    }
  },
];

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_ENV === "development" ? "" : "course",
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
